import slice, { selectors } from './single-product.slice';
import {
  getProductById,
  getPricelistCategories,
  getPricelistModifiers
} from './single-product.thunk';

export const singleProductActions = {
  ...slice.actions,
  getProductById,
  getPricelistCategories,
  getPricelistModifiers
};
export const singleProductReducer = slice.reducer;
export const singleProductSelectors = selectors;
